import React , {Component} from 'react';

class ErrorBoundries extends Component{
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        }
    }
    //this will activate when an error happens for that child component!
    componentDidCatch(error , info){
        this.setState({hasError:true})
    }

    render(){
        if(this.state.hasError){
            return <h1>Oooops! Something Went Wrong! Please Comeback Later!</h1>
        }
        //else return the children between this wrapper which is caled children!
        return this.props.children 
    }

}
export default ErrorBoundries;